import React, { useEffect, useState } from "react";
import API from "../../../services/api";
import { useAuth } from "../../../context/AuthContext";

const ManagerDashboard = () => {
  const { user } = useAuth();
  const [stats, setStats] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    API.get("/grievances/", { params: { page: 1, per_page: 100 } })
      .then((res) => {
        const grievances = res.data.data.grievances;
        const byStatus = {};
        const byPriority = {};
        grievances.forEach((g) => {
          byStatus[g.current_status] = (byStatus[g.current_status] || 0) + 1;
          byPriority[g.priority] = (byPriority[g.priority] || 0) + 1;
        });
        setStats({ total: grievances.length, byStatus, byPriority });
      })
      .catch((err) => console.error(err))
      .finally(() => setLoading(false));
  }, []);

  const statusColors = {
    New: "#3b82f6",
    InProgress: "#f59e0b",
    OnHold: "#6b7280",
    Resolved: "#10b981",
    Closed: "#1f2937",
    Escalated: "#ef4444",
  };

  return (
    <div>
      <div className="mb-4">
        <h4 className="fw-bold mb-1">Welcome, {user?.name} 👋</h4>
        <p className="text-muted small mb-0">
          Manager Dashboard — Grievances assigned to you
        </p>
      </div>

      {loading ? (
        <div className="text-center py-5">
          <div className="spinner-border text-warning"></div>
        </div>
      ) : (
        <>
          {/* Total Card */}
          <div className="row g-3 mb-4">
            <div className="col-12 col-md-4">
              <div className="card border-0 shadow-sm rounded-4 h-100">
                <div className="card-body d-flex align-items-center gap-3 p-4">
                  <div
                    className="rounded-3 d-flex align-items-center justify-content-center"
                    style={{ width: 56, height: 56, background: "#fef3c7" }}
                  >
                    <i
                      className="bi bi-chat-left-text-fill fs-4"
                      style={{ color: "#d97706" }}
                    ></i>
                  </div>
                  <div>
                    <div className="text-muted small">Total Assigned</div>
                    <div className="fw-bold fs-3">{stats?.total || 0}</div>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-12 col-md-4">
              <div className="card border-0 shadow-sm rounded-4 h-100">
                <div className="card-body d-flex align-items-center gap-3 p-4">
                  <div
                    className="rounded-3 d-flex align-items-center justify-content-center"
                    style={{ width: 56, height: 56, background: "#d1fae5" }}
                  >
                    <i
                      className="bi bi-check-circle-fill fs-4"
                      style={{ color: "#10b981" }}
                    ></i>
                  </div>
                  <div>
                    <div className="text-muted small">Resolved</div>
                    <div className="fw-bold fs-3">
                      {stats?.byStatus?.Resolved || 0}
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-12 col-md-4">
              <div className="card border-0 shadow-sm rounded-4 h-100">
                <div className="card-body d-flex align-items-center gap-3 p-4">
                  <div
                    className="rounded-3 d-flex align-items-center justify-content-center"
                    style={{ width: 56, height: 56, background: "#fee2e2" }}
                  >
                    <i
                      className="bi bi-exclamation-triangle-fill fs-4"
                      style={{ color: "#ef4444" }}
                    ></i>
                  </div>
                  <div>
                    <div className="text-muted small">Escalated</div>
                    <div className="fw-bold fs-3">
                      {stats?.byStatus?.Escalated || 0}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Status Breakdown */}
          <div className="row g-3">
            <div className="col-12 col-lg-6">
              <div className="card border-0 shadow-sm rounded-4">
                <div className="card-body p-4">
                  <h6 className="fw-semibold mb-3">
                    <i className="bi bi-bar-chart me-2 text-warning"></i>
                    Status Breakdown
                  </h6>
                  {stats?.byStatus &&
                    Object.entries(stats.byStatus).map(([status, count]) => (
                      <div key={status} className="mb-2">
                        <div className="d-flex justify-content-between small mb-1">
                          <span>{status}</span>
                          <span className="fw-semibold">{count}</span>
                        </div>
                        <div className="progress" style={{ height: "6px" }}>
                          <div
                            className="progress-bar"
                            style={{
                              width: `${(count / (stats.total || 1)) * 100}%`,
                              background: statusColors[status] || "#6b7280",
                            }}
                          ></div>
                        </div>
                      </div>
                    ))}
                </div>
              </div>
            </div>
            <div className="col-12 col-lg-6">
              <div className="card border-0 shadow-sm rounded-4">
                <div className="card-body p-4">
                  <h6 className="fw-semibold mb-3">
                    <i className="bi bi-flag me-2 text-danger"></i>
                    Priority Breakdown
                  </h6>
                  {stats?.byPriority &&
                    Object.entries(stats.byPriority).map(
                      ([priority, count]) => (
                        <div key={priority} className="mb-2">
                          <div className="d-flex justify-content-between small mb-1">
                            <span>{priority}</span>
                            <span className="fw-semibold">{count}</span>
                          </div>
                          <div className="progress" style={{ height: "6px" }}>
                            <div
                              className="progress-bar bg-danger"
                              style={{
                                width: `${(count / (stats.total || 1)) * 100}%`,
                              }}
                            ></div>
                          </div>
                        </div>
                      ),
                    )}
                </div>
              </div>
            </div>
          </div>
        </>
      )}
    </div>
  );
};

export default ManagerDashboard;
